package tta.destinigo.talktoastro.feature_call_consultation.data.response.queue_status


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import tta.destinigo.talktoastro.shared.data.CommonResponse

@Serializable
data class QueueStatusResponse(
    @SerialName("data") val `data`: List<QueueStatusData>? = null,
):CommonResponse()